import classNames from 'classnames';
import * as dayjs from 'dayjs';
import { t } from 'ttag';

import { ProductSaleStatus } from '@models';
import { useRegion } from '@hook/useRegion';

import s from './ProductSaleLabel.sss';

interface Props {
  className?: string,
  status: ProductSaleStatus,
  date: string,
  price: number,
  isShortMonthName?: boolean,
}

export const ProductSaleLabel: React.FC<Props> = ({
  className,
  status,
  date,
  price,
  isShortMonthName = true,
}) => {
  const region = useRegion();

  const currency = region.currencyName;
  const saleDateValue = date ? dayjs(date).format(`DD ${isShortMonthName ? 'MMM' : 'MMMM'}`) : null;

  if (status === ProductSaleStatus.SaleNone) {
    return null;
  }

  return (
    (
      <p className={classNames(s.root, className)}>
        {status === ProductSaleStatus.SaleStarted ? t`розпродаж до ${saleDateValue}` : t`${price} ${currency} з ${saleDateValue}`}
      </p>
    )
  );
};
